import { getProductTotals, transformers, modifierUtils } from '@artisan-commerce/products';

var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
const _State = class {
  constructor(state) {
    this._state = state;
    this._initialState = state;
  }
  static getInstance(initialState) {
    if (!_State._instance) {
      _State._instance = new _State(initialState);
    }
    return _State._instance;
  }
  setState(overrides) {
    this._state = __spreadValues$i(__spreadValues$i({}, this._state), overrides);
  }
  get state() {
    if (this._state === null) {
      throw new Error("The state has not been initialized, make sure to call State.init beforehand");
    }
    return this._state;
  }
  checkInit() {
    return !!this._state;
  }
  reset() {
    this._state = this._initialState;
  }
};
let State$1 = _State;
State$1._instance = null;

const CONSTANTS = {
  DEFAULT_SHOPPING_CART_NAME: "default",
  DEFAULT_MAX_SHOPPING_CARTS: 2
};

class ActionQueue {
  constructor() {
    this.queue = [];
  }
  get length() {
    return this.queue.length;
  }
  enqueue(newItem) {
    this.queue.push(newItem);
  }
  dequeue() {
    return this.queue.shift();
  }
}

class EventLoop {
  constructor() {
    this.running = false;
  }
  async run() {
    const { queue } = State().state;
    const next = queue.dequeue();
    if (!next) {
      this.running = false;
      return;
    }
    return await next();
  }
  get isRunning() {
    return this.running;
  }
  async start() {
    this.running = true;
    while (this.running) {
      await this.run();
    }
  }
}

const { DEFAULT_SHOPPING_CART_NAME: DEFAULT_SHOPPING_CART_NAME$2, DEFAULT_MAX_SHOPPING_CARTS } = CONSTANTS;
const initialState = {
  accountId: void 0,
  customerId: void 0,
  activeShoppingCart: DEFAULT_SHOPPING_CART_NAME$2,
  maxShoppingCarts: DEFAULT_MAX_SHOPPING_CARTS,
  wallets: {},
  anonymous: false,
  initialized: false,
  queue: new ActionQueue(),
  eventLoop: new EventLoop(),
  debug: false,
  platform: void 0
};
const State = () => {
  return State$1.getInstance(initialState);
};

var __defProp$h = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
const defaultSort = (a, b) => {
  if (a > b) {
    return 1;
  } else if (b > a) {
    return -1;
  } else {
    return 0;
  }
};
const sortByField = (field, a, b) => {
  const idA = a[field];
  const idB = b[field];
  if (idA > idB) {
    return 1;
  } else if (idB > idA) {
    return -1;
  } else {
    return 0;
  }
};
const sortByProductId = (a, b) => {
  return sortByField("productId", a, b);
};
const sortByQuestionId = (a, b) => {
  return sortByField("questionId", a, b);
};
const logError = (message) => {
  if (process.env.NODE_ENV === "production") {
    console.error(message);
  } else {
    throw new Error(message);
  }
};
const logDebug = (message) => {
  const { debug } = State().state;
  if (!debug)
    return;
  console.warn(message);
};
const reuseGlobalConfig = (config) => {
  const { debug: configDebug } = config != null ? config : {};
  const { store: configStore } = config != null ? config : {};
  const { accountId: configAccountId } = config != null ? config : {};
  const { anonymous: configAnonymous } = config != null ? config : {};
  const { customerId: configCustomerId } = config != null ? config : {};
  const { shoppingCartName: configCartName } = config != null ? config : {};
  const { maxShoppingCarts: configMaxShoppingCarts } = config != null ? config : {};
  const { accountId: globalAccountId } = State().state;
  const { customerId: globalCustomerId } = State().state;
  const { store: globalStore, anonymous: globalAnonymous } = State().state;
  const { activeShoppingCart: globalCartName } = State().state;
  const { maxShoppingCarts: globalMaxShoppingCarts } = State().state;
  const { debug: globalDebug } = State().state;
  const accountId = configAccountId != null ? configAccountId : globalAccountId;
  const customerId = configCustomerId != null ? configCustomerId : globalCustomerId;
  const prunedConfigStore = configStore ? __spreadProps$b(__spreadValues$h({}, configStore), { polygons: null }) : void 0;
  const store = prunedConfigStore != null ? prunedConfigStore : globalStore;
  const shoppingCartName = configCartName != null ? configCartName : globalCartName;
  const maxShoppingCarts = configMaxShoppingCarts != null ? configMaxShoppingCarts : globalMaxShoppingCarts;
  const anonymous = configAnonymous != null ? configAnonymous : globalAnonymous;
  const debug = configDebug != null ? configDebug : globalDebug;
  return __spreadProps$b(__spreadValues$h({}, config), {
    shoppingCartName,
    customerId,
    store,
    accountId,
    anonymous,
    maxShoppingCarts,
    debug
  });
};

var __defProp$g = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
const { DEFAULT_SHOPPING_CART_NAME: DEFAULT_SHOPPING_CART_NAME$1 } = CONSTANTS;
const initShoppingCart = (config = {}) => {
  const { initialized } = State().state;
  if (initialized) {
    logDebug(`initShoppingCart has been called more than once.
      This behavior will very likely result in unexpected outcomes so its
      call was skipped. Please make sure initShoppingCart is only called once`);
    return;
  }
  const { shoppingCartName } = config;
  State().setState(__spreadProps$a(__spreadValues$g({}, config), {
    activeShoppingCart: shoppingCartName != null ? shoppingCartName : DEFAULT_SHOPPING_CART_NAME$1
  }));
  const isServer = typeof window === "undefined";
  if (!isServer)
    State().setState({ initialized: true });
};
const closeShoppingCart = () => {
  State().reset();
};

var __defProp$f = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
const getStore = (storeData, stores) => {
  const { storeId } = storeData != null ? storeData : {};
  return __spreadValues$f(__spreadValues$f({}, storeData), stores[storeId]);
};
const checkInit = () => State().state.initialized;
const cleanShoppingCart = (shoppingCart, product) => {
  const { benefits } = shoppingCart;
  if (!(benefits == null ? void 0 : benefits.length))
    return shoppingCart;
  const benefit = benefits.find((benefit2) => {
    if (!product)
      return true;
    const { type } = benefit2;
    if (type !== "PRODUCT")
      return void 0;
    if (!Array.isArray(benefit2.award))
      return void 0;
    return benefit2.award.find((award) => award.productId.toString() === product.productId);
  });
  if (!benefit)
    return shoppingCart;
  delete shoppingCart.benefits;
  delete shoppingCart.benefitsHash;
  return shoppingCart;
};

const getShoppingCart = async (builders, config) => {
  const { getShoppingCartNode } = builders != null ? builders : {};
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        const { shoppingCartName } = reusedConfig;
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode || !checkInit()) {
          resolve(null);
          return null;
        }
        State().setState({ activeShoppingCart: shoppingCartName });
        const shoppingCart = shoppingCartNode.data();
        resolve(shoppingCart);
        return shoppingCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

const checkAccountId = (accountId, message = "") => {
  const { accountId: globalAccountId } = State().state;
  if (typeof accountId === "undefined" && typeof globalAccountId === "undefined") {
    throw new Error(`AccountId must be defined. Either provide a global accountId or at the function call level. ${message}`);
  }
};
const checkCustomerId = (customerId, message = "") => {
  const { customerId: globalCustomerId } = State().state;
  if (typeof customerId === "undefined" && typeof globalCustomerId === "undefined") {
    throw new Error(`CustomerId must be defined. Either provide a global customerId or at the function call level. ${message}`);
  }
};
const checkInitialized = () => {
  const { initialized } = State().state;
  if (!initialized) {
    throw new Error(`Shopping cart not initialized. Make sure initShoppingCart has been called.`);
  }
};
const checkStoreId = (store, message = "") => {
  const { store: globalStore } = State().state;
  if (typeof store === "undefined" && typeof globalStore === "undefined") {
    throw new Error(`Store must be defined. Either provide a global store or at the function call level. ${message}`);
  }
};
const checkApiURL = (apiURL, message = "") => {
  if (typeof apiURL === "undefined") {
    throw new Error(`ApiURL must be defined. Either provide a global ApiURL or at the function call level. ${message}`);
  }
};
const checkMinimumConfigProvided = (config = {}) => {
  const { accountId, customerId } = config;
  checkAccountId(accountId);
  checkCustomerId(customerId);
};
const checkBenefitConfigProvided = (wallets, cartName, config) => {
  const { benefitId } = config != null ? config : {};
  const activeWallet = wallets[cartName];
  const benefits = activeWallet == null ? void 0 : activeWallet.benefits;
  checkBenefitId(benefitId);
  if (!activeWallet || !benefits) {
    return `No benefits wallet available for ${cartName}, you probably forgot to call listenBenefitsWallet beforehand.`;
  }
};
const checkBenefitId = (benefitId) => {
  if (typeof benefitId !== "undefined")
    return;
  throw new Error(`BenefitId must be defined. Provide it at the function call level.`);
};
const checkVendorId = (vendorId, message = "") => {
  if (typeof vendorId === "undefined") {
    throw new Error(`VendorId must be defined. Provide a global vendorId at the function call level. ${message}`);
  }
};
const checkMinimumFetchWalletConfigProvided = (config) => {
  const { customerId } = config != null ? config : {};
  checkCustomerId(customerId);
};
const checkAuthToken = (authToken) => {
  if (!authToken) {
    throw new Error(`No auth token provided. Please make sure you provide one globally or a the function level call. You may included it in the Authorization header.`);
  }
  const validAuthToken = authToken.startsWith("Bearer ");
  if (!validAuthToken) {
    throw new Error(`The provided auth token is invalid. Please provide a valid one.`);
  }
};
const checkStoreCouponDetailConfig = (config, message = "") => {
  const { countryId, couponId } = config;
  if (typeof countryId === "undefined" || typeof couponId === "undefined") {
    throw new Error(`Country id or coupon id must be defined. Provide those params at the function call level. ${message}`);
  }
};

const checkProductAmount = (amount) => {
  if (typeof amount !== "number") {
    throw new Error("Invalid amount received, please make sure you include a valid amount.");
  }
  if (amount < 0) {
    throw new Error(`Cannot receive a negative amount of an item. Please ensure you have added a proper amount of items.`);
  }
  if (amount === 0) {
    throw new Error("Attempting to pass 0 amount. This might indicate a problem with your code. Please ensure you have added a proper amount of items.");
  }
};
const checkModifyProductConfig = (config) => {
  const { store, amount } = config;
  checkStoreId(store);
  checkProductAmount(amount);
};
const checkRemoveProductConfig = (config) => {
  const { store } = config;
  checkStoreId(store);
};
const checkReplaceProductConfig = (config) => {
  const { store } = config;
  checkStoreId(store);
};

var __defProp$e = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
const { toCartProduct: toCartProduct$4 } = transformers;
const { divideProductQA: divideProductQA$3 } = modifierUtils;
const getProductHash = (product) => {
  const resetedProduct = divideProductQA$3(product);
  const { productId, questionsAndAnswers, priceCategory } = resetedProduct;
  const prunedQuestions = pruneQuestionsAndAnswers(questionsAndAnswers);
  const sortedQuestions = prunedQuestions.sort(sortByQuestionId);
  const questionAndAnswersIds = sortedQuestions.reduce((acc, question) => {
    const sortedAnswers = question.answers.sort(sortByProductId);
    const answerIds = sortedAnswers.reduce((acc2, answer, index) => {
      const { productId: productId2, amount } = answer;
      const childrenHash = getProductHash(answer);
      const concatChildrenHash = childrenHash ? `{${childrenHash}}` : "";
      if (index === 0) {
        return `${productId2}=${amount}${concatChildrenHash}`;
      }
      return `${acc2}|${productId2}=${amount}${concatChildrenHash}`;
    }, "");
    const questionIds = `${question.questionId}:${answerIds}`;
    if (acc === "") {
      return `${questionIds}`;
    }
    return `${acc}-${questionIds}`;
  }, "");
  return `${productId}-${questionAndAnswersIds}*${priceCategory}`;
};
const pruneQuestionsAndAnswers = (questions) => {
  const prunedQuestions = questions.reduce((acc, question) => {
    const prunedAnswers = question.answers.filter((answer) => {
      return answer.amount > 0;
    });
    const prunedAnswersAndChildren = prunedAnswers.map((answer) => {
      const prunedChildren = pruneQuestionsAndAnswers(answer.questionsAndAnswers);
      return __spreadProps$9(__spreadValues$e({}, answer), { questionsAndAnswers: prunedChildren });
    });
    return [...acc, __spreadProps$9(__spreadValues$e({}, question), { answers: prunedAnswersAndChildren })];
  }, []);
  const prunedQuestionsAndAnswers = prunedQuestions.filter((question) => {
    return question.answers.length > 0;
  });
  return prunedQuestionsAndAnswers;
};
const getShoppingCartTotal = (shoppingCart, config = {}) => {
  const initialValue = {
    subtotal: 0,
    totalDiscounts: null,
    shippingCost: null,
    totalTaxes: null,
    totalPoints: null,
    total: 0
  };
  const products = getShoppingCartProducts(shoppingCart);
  if (!products.length)
    return initialValue;
  const totals = products.reduce((acc, product) => {
    const cartProduct = toCartProduct$4(product);
    const { priceCategory } = cartProduct;
    const productTotal = getProductTotals(cartProduct);
    const isPoints = priceCategory === "POINTS";
    const points = isPoints ? productTotal.netPrice : 0;
    const normal = !isPoints ? productTotal.netPrice : 0;
    const subtotalNormal = !isPoints ? productTotal.grossPrice : 0;
    return {
      subtotal: acc.subtotal + subtotalNormal,
      totalDiscounts: productTotal.totalDiscounts !== null ? Number(acc.totalDiscounts) + productTotal.totalDiscounts : null,
      totalTaxes: productTotal.totalTaxes !== null ? Number(acc.totalTaxes) + productTotal.totalTaxes : null,
      shippingCost: null,
      totalPoints: points !== null ? Number(acc.totalPoints) + points : null,
      total: acc.total + normal
    };
  }, initialValue);
  const totalsWithBenefits = applyBenefits(shoppingCart, totals);
  const { shippingCost = shoppingCart.shippingCost } = config;
  if (!shippingCost) {
    return totalsWithBenefits;
  }
  const { grossPrice, netPrice, taxTotal, discountTotal } = shippingCost;
  const totalsWithShippingCost = {
    subtotal: totalsWithBenefits.subtotal + grossPrice,
    totalDiscounts: totalsWithBenefits.totalDiscounts !== null ? totalsWithBenefits.totalDiscounts + discountTotal : discountTotal,
    totalTaxes: totalsWithBenefits.totalTaxes !== null ? totalsWithBenefits.totalTaxes + taxTotal : taxTotal,
    shippingCost: netPrice,
    totalPoints: totalsWithBenefits.totalPoints,
    total: totalsWithBenefits.total + netPrice
  };
  return totalsWithShippingCost;
};
const getShoppingCartProducts = (shoppingCart, storeId) => {
  let stores;
  if (typeof storeId === "undefined") {
    stores = Object.values(shoppingCart.stores);
  } else {
    stores = [shoppingCart.stores[storeId]];
  }
  return stores.reduce((acc, store) => {
    if (!store)
      return acc;
    const products = Object.values(store.products);
    return [...acc, ...products];
  }, []);
};
const applyBenefits = (shoppingCart, shoppingCartTotals) => {
  const additionalInfo = shoppingCart["additional_info"];
  const benefits = shoppingCart["benefits"];
  if (!benefits) {
    return shoppingCartTotals;
  }
  const benefitsValues = Object.values(benefits);
  return benefitsValues.reduce((acc, benefit) => {
    if (benefit.type === "DISCOUNT_PERCENTAGE" && benefit.discountPercentage) {
      return applyBenefitByDiscountPercentage(benefit, acc, shoppingCart);
    }
    if (benefit.type === "DISCOUNT_FIXED" && benefit.discountFixed) {
      return applyBenefitByDiscountFixed(benefit, acc, additionalInfo);
    }
    return acc;
  }, shoppingCartTotals);
};
const applyBenefitByDiscountPercentage = (benefit, shoppingCartTotals, shoppingCart) => {
  const additionalInfo = shoppingCart["additional_info"];
  const { billTotal } = shoppingCart;
  const { NORMAL } = billTotal;
  const { taxes } = NORMAL != null ? NORMAL : {};
  const { subtotal, total: prevTotal } = shoppingCartTotals;
  const { totalDiscounts: prevTotalDiscounts } = shoppingCartTotals;
  const { totalTaxes: prevTaxes } = shoppingCartTotals;
  const discountPercentage = benefit.discountPercentage * 0.01;
  if (typeof (additionalInfo == null ? void 0 : additionalInfo.copayment) !== "undefined") {
    const copayment = additionalInfo == null ? void 0 : additionalInfo.copayment;
    const totalDiscount2 = copayment * discountPercentage;
    const newTotalDiscounts2 = prevTotalDiscounts !== null ? prevTotalDiscounts + totalDiscount2 : totalDiscount2;
    const newTotal2 = (copayment - totalDiscount2).toFixed(4);
    return __spreadProps$9(__spreadValues$e({}, shoppingCartTotals), {
      totalDiscounts: newTotalDiscounts2,
      total: Number(newTotal2)
    });
  }
  const totalDiscount = subtotal * discountPercentage;
  let newTotalTax = 0;
  taxes == null ? void 0 : taxes.forEach((tax) => {
    newTotalTax += (subtotal - totalDiscount) * tax.percentage * 0.01;
  });
  const taxesDiff = prevTaxes ? prevTaxes - newTotalTax : newTotalTax;
  const newTotalDiscounts = prevTotalDiscounts !== null ? prevTotalDiscounts + totalDiscount : totalDiscount;
  const newTotal = prevTotal - totalDiscount - taxesDiff;
  return __spreadProps$9(__spreadValues$e({}, shoppingCartTotals), {
    totalDiscounts: newTotalDiscounts,
    total: newTotal,
    totalTaxes: newTotalTax
  });
};
const applyBenefitByDiscountFixed = (benefit, shoppingCartTotals, additionalInfo) => {
  const { total: prevTotal } = shoppingCartTotals;
  const { totalDiscounts: prevTotalDiscounts } = shoppingCartTotals;
  const discountFixed = Number(benefit.discountFixed);
  if (typeof (additionalInfo == null ? void 0 : additionalInfo.copayment) !== "undefined") {
    const copayment = additionalInfo == null ? void 0 : additionalInfo.copayment;
    const newTotalDiscounts2 = prevTotalDiscounts !== null ? prevTotalDiscounts + discountFixed : discountFixed;
    const newTotal2 = (copayment - discountFixed).toFixed(4);
    return __spreadProps$9(__spreadValues$e({}, shoppingCartTotals), {
      totalDiscounts: newTotalDiscounts2,
      total: Number(newTotal2)
    });
  }
  const newTotalDiscounts = prevTotalDiscounts !== null ? prevTotalDiscounts + discountFixed : discountFixed;
  const newTotal = prevTotal - discountFixed;
  return __spreadProps$9(__spreadValues$e({}, shoppingCartTotals), {
    totalDiscounts: newTotalDiscounts,
    total: newTotal
  });
};
const findProduct = async (builders, config) => {
  const { getShoppingCartNode } = builders != null ? builders : {};
  const { shoppingCartName } = config;
  const { accountId, customerId, hash, productId, store } = config;
  try {
    if (!hash && typeof productId === "undefined") {
      throw new Error(`You must provide either a product id or a product hash,
        but none were given.`);
    }
    const shoppingCart = await getShoppingCart({ getShoppingCartNode }, {
      accountId,
      customerId,
      store,
      shoppingCartName
    });
    if (!shoppingCart)
      return;
    const products = getShoppingCartProducts(shoppingCart);
    let product;
    if (hash) {
      product = products.find((item) => item.hash === hash);
    } else {
      product = products.find((item) => item.productId === productId);
    }
    return product;
  } catch (e) {
    console.error(e);
    return void 0;
  }
};

var __defProp$d = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
const { toCartProduct: toCartProduct$3 } = transformers;
const { multiplyProductQA: multiplyProductQA$2, divideProductQA: divideProductQA$2 } = modifierUtils;
const addProduct = async (builders, product, config) => {
  const { getShoppingCartNode, setDoc, createShoppingCart } = builders != null ? builders : {};
  const { createCart } = config;
  if (createCart) {
    const reusedConfig = reuseGlobalConfig(config);
    const shoppingCart = await getShoppingCart(builders, reusedConfig);
    if (!shoppingCart)
      await (createShoppingCart == null ? void 0 : createShoppingCart(reusedConfig, createCart === true ? void 0 : createCart));
  }
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        checkModifyProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot add a product because no shopping cart node was found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const updatedCart = addProductToCartHelper(shoppingCart, product, config);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const addProductToCartHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkModifyProductConfig(reusedConfig);
  }
  const { amount: originalAmount } = product;
  const amount = originalAmount ? originalAmount : 1;
  const hashCartProduct = toCartProduct$3(product, __spreadProps$8(__spreadValues$d({}, reusedConfig), {
    amount: amount != null ? amount : 1
  }));
  const cartProduct = toCartProduct$3(product, reusedConfig);
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const hash = getProductHash(hashCartProduct);
  const updatedCart = __spreadValues$d({}, shoppingCart);
  const stores = __spreadValues$d({}, shoppingCart.stores);
  const store = getStore(configStore, stores);
  const products = __spreadValues$d({}, store.products);
  const productExist = products[hash];
  const now = new Date().toISOString();
  if (!productExist) {
    products[hash] = cartProduct;
    products[hash].hash = hash;
    products[hash].createdAt = now;
  } else {
    products[hash] = divideProductQA$2(products[hash]);
    products[hash].amount += cartProduct.amount;
  }
  products[hash].updatedAt = now;
  let updatedProduct = products[hash];
  updatedProduct = multiplyProductQA$2(updatedProduct);
  const { questionsAndAnswers } = updatedProduct;
  const newCartModifiers = pruneQuestionsAndAnswers(questionsAndAnswers);
  products[hash] = __spreadProps$8(__spreadValues$d({}, updatedProduct), { questionsAndAnswers: newCartModifiers });
  store.products = products;
  stores[storeId] = store;
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$c = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
const { toCartProduct: toCartProduct$2 } = transformers;
const { multiplyProductQA: multiplyProductQA$1, divideProductQA: divideProductQA$1 } = modifierUtils;
const subtractProduct = async (builders, product, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { setDoc, getShoppingCartNode } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        checkModifyProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot subtract product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const updatedCart = subtractProductHelper(shoppingCart, product, reusedConfig);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const subtractProductHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkModifyProductConfig(reusedConfig);
  }
  const { amount: originalAmount } = product;
  const amount = originalAmount ? originalAmount : 1;
  const hashCartProduct = toCartProduct$2(product, __spreadProps$7(__spreadValues$c({}, reusedConfig), {
    amount: amount != null ? amount : 1
  }));
  const cartProduct = toCartProduct$2(product, reusedConfig);
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const hash = getProductHash(hashCartProduct);
  let updatedCart = __spreadValues$c({}, shoppingCart);
  const stores = __spreadValues$c({}, shoppingCart.stores);
  if (typeof stores[storeId] === "undefined") {
    console.warn(`StoreId given is invalid. There is no store with id ${storeId} on the shopping cart.`);
    return shoppingCart;
  }
  const store = getStore(configStore, stores);
  const products = __spreadValues$c({}, store.products);
  const productExist = products[hash];
  const now = new Date().toISOString();
  if (!productExist) {
    console.warn(`Attempting to subtract the amount of product that is not in the given shopping cart store.`);
    return shoppingCart;
  }
  products[hash] = divideProductQA$1(products[hash]);
  const newAmount = products[hash].amount - cartProduct.amount;
  if (newAmount > 0) {
    products[hash].amount = newAmount;
    products[hash].updatedAt = now;
    products[hash] = multiplyProductQA$1(products[hash]);
  } else {
    delete products[hash];
    updatedCart = cleanShoppingCart(shoppingCart, product);
  }
  store.products = products;
  if (!Object.keys(store.products).length) {
    delete stores[storeId];
  } else {
    stores[storeId] = store;
  }
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
const { toCartProduct: toCartProduct$1 } = transformers;
const removeProduct = async (builders, product, config = {}) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { setDoc, getShoppingCartNode } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        checkRemoveProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot remove a product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const cart = removeProductHelper(shoppingCart, product, reusedConfig);
        const updatedCart = cleanShoppingCart(cart, product);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const removeProductHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkRemoveProductConfig(reusedConfig);
  }
  let productHash = product.hash;
  if (!productHash) {
    const cartProduct = toCartProduct$1(product);
    productHash = getProductHash(cartProduct);
  }
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const updatedCart = __spreadValues$b({}, shoppingCart);
  const stores = __spreadValues$b({}, shoppingCart.stores);
  if (typeof stores[storeId] === "undefined") {
    console.warn(`StoreId given is invalid. There is no store with id ${storeId} on the shopping cart.`);
    return shoppingCart;
  }
  const store = getStore(configStore, stores);
  const products = __spreadValues$b({}, store.products);
  const productExist = products[productHash];
  if (!productExist) {
    console.warn(`Attempting to remove product that is not in the given shopping cart store.`);
    return shoppingCart;
  }
  delete products[productHash];
  store.products = products;
  if (!Object.keys(store.products).length) {
    delete stores[storeId];
  } else {
    stores[storeId] = store;
  }
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$a = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
const { toCartProduct } = transformers;
const { multiplyProductQA, divideProductQA } = modifierUtils;
const setProduct = async (builders, product, config = {}) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      var _a, _b;
      try {
        const { setDoc, getShoppingCartNode } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        const amount = (_b = (_a = reusedConfig.amount) != null ? _a : product == null ? void 0 : product.amount) != null ? _b : 1;
        const actionConfig = __spreadProps$6(__spreadValues$a({}, reusedConfig), { amount });
        checkModifyProductConfig(actionConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot set product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const cart = setProductHelper(shoppingCart, product, actionConfig);
        const updatedCart = cleanShoppingCart(cart, product);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const setProductHelper = (shoppingCart, product, config) => {
  var _a;
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkModifyProductConfig(reusedConfig);
  }
  const amount = (_a = product == null ? void 0 : product.amount) != null ? _a : 1;
  const hashCartProduct = toCartProduct(product, __spreadProps$6(__spreadValues$a({}, reusedConfig), { amount }));
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const hash = getProductHash(hashCartProduct);
  const updatedCart = __spreadValues$a({}, shoppingCart);
  const stores = __spreadValues$a({}, shoppingCart.stores);
  const store = getStore(configStore, stores);
  const products = __spreadValues$a({}, store.products);
  const productExist = products[hash];
  const now = new Date().toISOString();
  products[hash] = hashCartProduct;
  if (!productExist) {
    products[hash].createdAt = now;
    products[hash].hash = hash;
  } else {
    products[hash] = divideProductQA(products[hash]);
  }
  products[hash].updatedAt = now;
  let updatedProduct = toCartProduct(products[hash], reusedConfig);
  updatedProduct = multiplyProductQA(updatedProduct);
  const { questionsAndAnswers } = updatedProduct;
  const newCartModifiers = pruneQuestionsAndAnswers(questionsAndAnswers);
  products[hash] = __spreadProps$6(__spreadValues$a({}, updatedProduct), { questionsAndAnswers: newCartModifiers });
  store.products = products;
  stores[storeId] = __spreadProps$6(__spreadValues$a({}, store), { polygons: null });
  updatedCart.stores = stores;
  return updatedCart;
};

var __defProp$9 = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
const replaceProduct = async (builders, product, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { setDoc, getShoppingCartNode } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        checkReplaceProductConfig(reusedConfig);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn("Cannot replace product because no shopping cart nodes found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        const cart = replaceProductHelper(shoppingCart, product, reusedConfig);
        const updatedCart = cleanShoppingCart(cart, product);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const replaceProductHelper = (shoppingCart, product, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  if (process.env.NODE_ENV === "test") {
    checkReplaceProductConfig(reusedConfig);
  }
  const { hash: configHash } = reusedConfig;
  const hash = configHash != null ? configHash : product.hash;
  const { store: configStore } = reusedConfig;
  const { storeId } = configStore != null ? configStore : {};
  const stores = __spreadValues$9({}, shoppingCart.stores);
  const store = getStore(configStore, stores);
  const products = __spreadValues$9({}, store.products);
  const productExist = products[hash];
  if (!productExist) {
    console.warn("Cannot replace a product because no product was found in the given store");
    return shoppingCart;
  }
  delete products[hash];
  store.products = products;
  if (!Object.keys(store.products).length) {
    delete stores[storeId];
  } else {
    stores[storeId] = store;
  }
  let updatedCart = __spreadValues$9({}, shoppingCart);
  updatedCart.stores = stores;
  const newProduct = __spreadProps$5(__spreadValues$9({}, product), { amount: 0 });
  updatedCart = addProductToCartHelper(updatedCart, newProduct, reusedConfig);
  return updatedCart;
};

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
const { DEFAULT_SHOPPING_CART_NAME } = CONSTANTS;
const buildInitialShoppingCart = (overrides = {}) => {
  const date = new Date().toISOString();
  return __spreadValues$8({
    id: "",
    name: DEFAULT_SHOPPING_CART_NAME,
    latitude: -1,
    longitude: -1,
    createdAt: date,
    updatedAt: date,
    channelId: 1,
    stores: {},
    billTotal: {},
    shippingCost: null
  }, overrides);
};

var __defProp$7 = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
const emptyShoppingCart = async (builders, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { getShoppingCartNode, setDoc } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        const { shoppingCartName, vendorId } = reusedConfig;
        if (!shoppingCartNode) {
          logDebug(`Cannot empty cart, shopping cart nodes not found. Please ensure you have a shopping cart with name ${shoppingCartName} before continue.`);
          resolve(null);
          return null;
        }
        const shoppingCart = await shoppingCartNode.data();
        delete shoppingCart.pickUpTime;
        const stores = {};
        if (typeof vendorId !== "undefined") {
          const filteredStores = Object.values(shoppingCart.stores).filter((store) => store.vendor.id != vendorId);
          filteredStores.forEach((store) => {
            stores[`${store.storeId}`] = store;
          });
        }
        const cart = __spreadProps$4(__spreadValues$7({}, shoppingCart), { stores });
        const updatedCart = cleanShoppingCart(cart);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

const deleteShoppingCart = async (builders, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { getShoppingCartNode, deleteDoc } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        const { shoppingCartName } = reusedConfig;
        if (!shoppingCartNode) {
          logDebug(`Couldn't find any shopping cart with name ${shoppingCartName} with the given config.`);
          resolve(null);
          return null;
        }
        const shoppingCart = shoppingCartNode.data();
        await (deleteDoc == null ? void 0 : deleteDoc({ shoppingCartNode, reusedConfig }));
        resolve(shoppingCart);
        return shoppingCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

const verifyHeaders = (headers) => {
  var _a;
  const validPlatforms = [
    "web",
    "ios",
    "android",
    "windows",
    "macos",
    "call center"
  ];
  const platform = headers.get("Platform");
  const validPlatformsText = validPlatforms.join(", ");
  if (!headers.has("account")) {
    throw new Error("Missing account headers");
  }
  if (!headers.has("Authorization")) {
    throw new Error("Missing Authorization header");
  }
  if (!platform) {
    throw new Error("Missing Platform header");
  }
  if (!validPlatforms.includes(platform)) {
    throw new Error(`Invalid header Platform: ${platform}, please use ${validPlatformsText}`);
  }
  checkAuthToken((_a = headers.get("Authorization")) != null ? _a : void 0);
};

const checkValidateShoppingCartConfig = (config, headers = new Headers()) => {
  const { apiURL } = config;
  checkApiURL(apiURL);
  verifyHeaders(headers);
};

const commonHeaders = {
  "Content-Type": "application/json"
};

var __defProp$6 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
const buildServiceHeaders = (headers = new Headers()) => {
  var _a, _b, _c, _d, _e;
  const { accountId, platform: platformState } = State().state;
  const account = (_b = (_a = headers.get("account")) != null ? _a : accountId == null ? void 0 : accountId.toString()) != null ? _b : "";
  const platform = (_d = (_c = headers.get("Platform")) != null ? _c : platformState) != null ? _d : "";
  const authorization = (_e = headers.get("Authorization")) != null ? _e : "";
  const enhancedHeaders = new Headers(__spreadProps$3(__spreadValues$6({}, commonHeaders), {
    authorization,
    platform,
    account
  }));
  headers.forEach((value, key) => {
    if (key.toLowerCase() === "authorization" || key.toLowerCase() === "platform" || key.toLowerCase() === "account") {
      return;
    }
    enhancedHeaders.set(key, value);
  });
  return enhancedHeaders;
};

const validateShoppingCart$1 = async (config, headers = new Headers()) => {
  const { id, latitude, longitude, apiURL } = config;
  const selectedHeaders = buildServiceHeaders(headers);
  verifyHeaders(selectedHeaders);
  let url = `${apiURL}/api/shopping-cart/${id}/validateShoppingCart`;
  try {
    if (typeof latitude !== "undefined" && typeof longitude !== "undefined") {
      url += `?latitude=${latitude}&longitude=${longitude}`;
    }
    const data = await fetch(url, {
      headers: selectedHeaders
    }).then(async (data2) => {
      return await data2.json();
    });
    const shoppingCart = data.data;
    if (!shoppingCart)
      throw new Error("No shopping cart was found.");
    const storeAlerts = Object.values(shoppingCart.stores).reduce((acc, store) => {
      if (store.alerts.length)
        return [...acc, ...store.alerts];
      return acc;
    }, []);
    const products = getShoppingCartProducts(shoppingCart);
    const productsAlerts = products.map((item) => item.alerts).flat();
    const alerts = {
      stores: storeAlerts,
      products: productsAlerts
    };
    return alerts;
  } catch (e) {
    console.error(e.message);
    return {
      stores: [
        {
          errorLevel: 1,
          message: "Ocurri\xF3 un error desconocido, comun\xEDquese con soporte",
          type: ""
        }
      ],
      products: []
    };
  }
};

const validateShoppingCart = async (builders, config = {}, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const { getShoppingCartNode } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  checkValidateShoppingCartConfig(reusedConfig, selectedHeaders);
  const { latitude, longitude, shoppingCartName, apiURL } = reusedConfig;
  const shoppingCartNode = await getShoppingCartNode(reusedConfig);
  const { id } = shoppingCartNode != null ? shoppingCartNode : {};
  if (typeof id === "undefined") {
    console.error(`Cannot use undefined as a shopping cart id. Shopping cart ${shoppingCartName} was not found. Validation canceled.`);
    return;
  }
  if (typeof apiURL === "undefined") {
    console.error("apiURL must be provided");
    return;
  }
  return await validateShoppingCart$1({ id, latitude, longitude, apiURL }, selectedHeaders);
};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
const unsubscriber = (shoppingCartName, unsubscribe) => {
  const { wallets } = State().state;
  const newWallets = __spreadValues$5({}, wallets);
  delete newWallets[shoppingCartName];
  State().setState({ wallets: newWallets });
  if (unsubscribe)
    unsubscribe();
};

const fetchWalletByUser = async (config, headers = new Headers()) => {
  const { vendorId, customerId, apiURL } = config;
  const selectedHeaders = buildServiceHeaders(headers);
  verifyHeaders(selectedHeaders);
  selectedHeaders.set("uid", customerId.toString());
  let serviceURL = "/api/shopping-cart/retrieveBenefits";
  if (vendorId)
    serviceURL = serviceURL + `?vendorId=${vendorId}`;
  const url = `${apiURL}${serviceURL}`;
  const data = await fetch(url, {
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  }).catch((e) => {
    throw new Error(`Failed to retrieve the user's wallet
 ${e.message}`);
  });
  if (!data) {
    throw new Error(`The benefits wallet is not defined. Make sure coupons are well configured`);
  }
};
const redeemCouponService = async (config, code, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const { customerId, apiURL } = config;
  verifyHeaders(selectedHeaders);
  selectedHeaders.set("uid", customerId.toString());
  try {
    const url = `${apiURL}/api/wallet_profit/apply`;
    const result = await fetch(url, {
      method: "post",
      body: JSON.stringify({ code }),
      headers: selectedHeaders
    }).then(async (data2) => {
      return await data2.json();
    });
    const response = result;
    const { code: responseCode, data, message } = response;
    if (responseCode === 200)
      return true;
    if (!data)
      throw new Error(message);
    logError(`Unhandled response when redeeming coupon ${JSON.stringify(response, void 0, 2)}`);
    return false;
  } catch (e) {
    throw new Error(e.message);
  }
};
const applyBenefitService = async (config, headers = new Headers()) => {
  var _a, _b;
  const selectedHeaders = buildServiceHeaders(headers);
  const { benefit, customerId, shoppingCartId, apiURL } = config;
  const { benefitId } = benefit;
  verifyHeaders(selectedHeaders);
  selectedHeaders.set("uid", customerId.toString());
  const selectedBenefitBody = {
    benefitId,
    shoppingCartId
  };
  const url = `${apiURL}/api/shopping-cart/applyBenefit`;
  const data = await fetch(url, {
    method: "post",
    body: JSON.stringify(selectedBenefitBody),
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  });
  if ((data == null ? void 0 : data.code) !== 200) {
    throw new Error((_b = (_a = data.message) == null ? void 0 : _a.message) != null ? _b : data.message);
  }
  if ((data == null ? void 0 : data.data.length) === 0) {
    throw new Error("No benefits were applied to the current shopping cart");
  }
  return data;
};
const fetchStoreCoupons = async (config, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const { vendorId, apiURL } = config;
  checkVendorId(vendorId);
  const url = `${apiURL}/api/couponByPromotion/categories?orderBy=created_at&sortBy=DESC&vendorId=${vendorId}`;
  verifyHeaders(selectedHeaders);
  const data = await fetch(url, {
    method: "get",
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  });
  if ((data == null ? void 0 : data.code) !== 200)
    throw new Error(data.message);
  return data.data;
};
const fetchStoreCouponDetail = async (config, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const { couponId, countryId, apiURL } = config;
  checkStoreCouponDetailConfig(config);
  const url = `${apiURL}/api/coupon/${couponId}?countryId=${countryId}`;
  verifyHeaders(selectedHeaders);
  const data = await fetch(url, {
    method: "get",
    headers: selectedHeaders
  }).then(async (data2) => {
    return await data2.json();
  });
  if ((data == null ? void 0 : data.code) !== 200)
    throw new Error(data.message);
  return data.data;
};

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
const applyBenefit = async (builders, config, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const reusedConfig = reuseGlobalConfig(config);
  checkMinimumConfigProvided(reusedConfig);
  const { benefitId, shoppingCartName } = reusedConfig;
  const { wallets } = State().state;
  const errorMessage = checkBenefitConfigProvided(wallets, shoppingCartName, reusedConfig);
  if (errorMessage) {
    logError(errorMessage);
    return;
  }
  const activeWallet = wallets[shoppingCartName];
  const benefits = activeWallet.benefits;
  const benefitToApply = benefits.find((benefit) => benefit.benefitId === benefitId);
  if (!benefitToApply) {
    logError(`No benefit was found in the benefits wallet with the benefitId provided.`);
    return;
  }
  const { type: benefitType } = benefitToApply;
  switch (benefitType) {
    case "PRODUCT":
      return applyProductBenefitHelper(builders, reusedConfig, benefitToApply);
    case "ALTER_DELIVERY":
      return applyAlterDeliveryBenefitHelper(builders, reusedConfig, benefitToApply, selectedHeaders);
    case "DISCOUNT_PERCENTAGE":
    case "DISCOUNT_FIXED":
      return applyDiscountBenefitHelper(builders, reusedConfig, benefitToApply, selectedHeaders);
    default:
      logError("The benefit to be applied is not of type PRODUCT, DISCOUNT_PERCENTAGE, DISCOUNT_FIXED or ALTER_DELIVERY.");
      break;
  }
};
const applyProductBenefitHelper = async (builders, config, benefit) => {
  const { applyBenefitsToCart } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  const { product, productConfig, anonymous } = reusedConfig;
  const { benefitId } = benefit;
  if (!product || !productConfig) {
    logError(`The product or the product configuration has not been provided to apply the selected benefit.`);
    return;
  }
  product.benefitId = benefitId;
  await (applyBenefitsToCart == null ? void 0 : applyBenefitsToCart(reusedConfig, benefit));
  await addProduct(builders, product, __spreadValues$4({
    anonymous
  }, productConfig));
};
const applyAlterDeliveryBenefitHelper = async (builders, config, benefit, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const { applyBenefitsToCart, getShoppingCartNode } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  const { shippingCost, latitude, longitude } = reusedConfig;
  if (!shippingCost || !latitude || !longitude) {
    logError("The shippingCost, latitude and longitude are required to apply the selected benefit.");
    return;
  }
  const { benefitWalletId, award } = benefit;
  if (Array.isArray(award)) {
    logError("To apply a ALTER_DELIVERY benefit, the award associated with the benefit cannot be an array.");
    return;
  }
  const { benefitId: awardBenefitId, discountPercentage } = award;
  const { subtotalBeforeTaxes } = shippingCost;
  const value = subtotalBeforeTaxes * (discountPercentage / 100);
  const benefitList = [];
  benefitList.push({
    benefitWalletId,
    benefitId: awardBenefitId,
    discountBase: subtotalBeforeTaxes,
    percentage: discountPercentage,
    priceCategory: "NORMAL",
    value
  });
  shippingCost.discounts = benefitList;
  await (applyBenefitsToCart == null ? void 0 : applyBenefitsToCart(reusedConfig, benefit, shippingCost));
  await validateShoppingCart({ getShoppingCartNode }, reusedConfig, selectedHeaders);
};
const applyBenefitsHelper = (shoppingCart, benefit, shippingCost) => {
  const { hash } = benefit;
  const { benefits } = shoppingCart;
  const temporalBenefits = benefits != null ? benefits : [];
  temporalBenefits.push(benefit);
  shoppingCart.benefits = temporalBenefits;
  shoppingCart.benefitsHash = hash;
  if (shippingCost)
    shoppingCart.shippingCost = shippingCost;
  return shoppingCart;
};
const applyDiscountBenefitHelper = async (builders, config, benefit, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const reuseConfig = reuseGlobalConfig(config);
  const { customerId, shoppingCartId, shoppingCartName, apiURL } = reuseConfig;
  if (!customerId) {
    logError("To apply a DISCOUNT_PERCENTAGE or DISCOUNT_FIXED benefit, a customerId must be provided.");
    return;
  }
  if (!shoppingCartId) {
    logError("To apply a DISCOUNT_PERCENTAGE or DISCOUNT_FIXED benefit, a shoppingCartId must be provided.");
    return;
  }
  const shoppingCart = await getShoppingCart(builders, reuseConfig);
  if (!shoppingCart) {
    logError(`Cannot apply discount benefit because no shopping cart was found. Please ensure you create a shopping cart with name ${shoppingCartName} before continue.`);
    return;
  }
  const { subtotal } = getShoppingCartTotal(shoppingCart);
  if (benefit.type === "DISCOUNT_FIXED" && subtotal < Number(benefit.discountFixed)) {
    logError("Cannot apply DISCOUNT_FIXED benefit because discount is greater than cart subtotal.");
    return;
  }
  await applyBenefitService({ benefit, customerId, shoppingCartId, apiURL }, selectedHeaders);
};

var __defProp$3 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const removeBenefit = async (builders, config) => {
  const { getShoppingCartNode, removeBenefitsFromCart } = builders != null ? builders : {};
  const { removeProduct } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  checkMinimumConfigProvided(reusedConfig);
  const { benefitId, shoppingCartName } = reusedConfig;
  const { wallets } = State().state;
  const errorMessage = checkBenefitConfigProvided(wallets, shoppingCartName, reusedConfig);
  if (errorMessage) {
    logError(errorMessage);
    return;
  }
  const activeWallet = wallets[shoppingCartName];
  const benefits = activeWallet.benefits;
  const benefitToRemove = benefits.find((benefit) => benefit.benefitId === benefitId);
  if (!benefitToRemove) {
    logError(`No benefit was found in the benefits wallet with the benefitId provided.`);
    return;
  }
  const { type: benefitType } = benefitToRemove;
  switch (benefitType) {
    case "PRODUCT":
      return removeProductBenefitHelper({ getShoppingCartNode, removeBenefitsFromCart, removeProduct }, reusedConfig, benefitToRemove);
    case "ALTER_DELIVERY":
      return removeAlterDeliveryBenefitHelper({ getShoppingCartNode, removeBenefitsFromCart }, reusedConfig, benefitToRemove);
    case "DISCOUNT_PERCENTAGE":
    case "DISCOUNT_FIXED":
      return removeBenefitsFromCart == null ? void 0 : removeBenefitsFromCart(reusedConfig, benefitToRemove);
    default:
      logError("The benefit to be removed is not of type PRODUCT, DISCOUNT_PERCENTAGE, DISCOUNT_FIXED or ALTER_DELIVERY.");
      break;
  }
};
const removeProductBenefitHelper = async (builders, config, benefit) => {
  const { removeBenefitsFromCart } = builders != null ? builders : {};
  const { removeProduct } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  const { product, productConfig } = reusedConfig;
  const { store } = productConfig != null ? productConfig : {};
  if (!product || !store) {
    logError("The cart product and the store, inside benefitProductConfig object, are required to remove the selected benefit.");
    return;
  }
  reusedConfig.productConfig.store = __spreadProps$2(__spreadValues$3({}, store), { polygons: null });
  await (removeBenefitsFromCart == null ? void 0 : removeBenefitsFromCart(reusedConfig, benefit));
  await (removeProduct == null ? void 0 : removeProduct(product, productConfig));
};
const removeAlterDeliveryBenefitHelper = async (builders, config, benefit) => {
  const { removeBenefitsFromCart } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  const { shippingCost } = reusedConfig;
  if (!shippingCost) {
    logError(`The shippingCost is require to remove the selected benefit.`);
    return;
  }
  return removeBenefitsFromCart == null ? void 0 : removeBenefitsFromCart(reusedConfig, benefit, shippingCost);
};
const removeBenefitsHelper = (shoppingCart, benefit, shippingCost) => {
  const { benefits } = shoppingCart;
  const { benefitId } = benefit;
  if (!benefits) {
    console.warn(`Cannot remove benefit because the shopping cart does not have benefits applied.`);
    return shoppingCart;
  }
  const benefitIdIndex = benefits.findIndex((benefit2) => benefit2.benefitId === benefitId);
  if (benefitIdIndex < 0) {
    console.warn(`This benefit cannot be removed because it is not applied to the shopping cart.`);
    return shoppingCart;
  }
  benefits.splice(benefitIdIndex, 1);
  delete shoppingCart.benefitsHash;
  if (shippingCost)
    shoppingCart.shippingCost = shippingCost;
  return shoppingCart;
};

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const getInitialBenefitsWallet = (overrides = {}) => {
  return __spreadValues$2({ benefits: [] }, overrides);
};
const mapCollectionToBenefits = (benefitsNode, hash) => {
  const benefits = Object.values(benefitsNode).map((benefit) => {
    const newBenefit = __spreadProps$1(__spreadValues$2({}, benefit), { hash });
    return newBenefit;
  });
  return benefits;
};
const updateBenefitsWallets = (walletName, newWallet) => {
  const { wallets } = State().state;
  const newWallets = __spreadProps$1(__spreadValues$2({}, wallets), {
    [walletName]: __spreadValues$2({}, newWallet)
  });
  State().setState({ wallets: newWallets });
};
const getBenefitsNode = async (builders, config = {}) => {
  const { getBenefitsCollection } = builders != null ? builders : {};
  const { accountId: globalAccountId } = State().state;
  const { customerId: globalCustomerId } = State().state;
  const { accountId, customerId } = config;
  checkMinimumConfigProvided(config);
  const benefitsCollection = await (getBenefitsCollection == null ? void 0 : getBenefitsCollection("benefitsByUser", String(customerId != null ? customerId : globalCustomerId), String(accountId != null ? accountId : globalAccountId)));
  return benefitsCollection;
};
const getWalletNode = async (builders, config) => {
  try {
    const { getBenefitsDocuments } = builders != null ? builders : {};
    const benefitsCollection = await getBenefitsNode(builders, config);
    if (!benefitsCollection)
      return;
    const newestBenefits = await (getBenefitsDocuments == null ? void 0 : getBenefitsDocuments(benefitsCollection));
    return newestBenefits;
  } catch (e) {
    console.error(e.message);
  }
};
const getWallet = async (builders, config) => {
  const benefitsByUserNode = await getWalletNode(builders, config);
  if (!benefitsByUserNode)
    return;
  if (Object.keys(benefitsByUserNode.data()).length === 0)
    return [];
  const hash = benefitsByUserNode.id;
  const benefitsData = Object.values(benefitsByUserNode.data());
  const benefits = benefitsData.map((benefit) => {
    const newBenefit = __spreadProps$1(__spreadValues$2({}, benefit), { hash });
    return newBenefit;
  });
  return benefits;
};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const redeemCoupon = async (builders, config, code, headers = new Headers()) => {
  const selectedHeaders = buildServiceHeaders(headers);
  const { getWallet } = builders != null ? builders : {};
  const reusedConfig = reuseGlobalConfig(config);
  const { customerId, shoppingCartName } = reusedConfig;
  checkMinimumConfigProvided(reusedConfig);
  verifyHeaders(selectedHeaders);
  const { wallets } = State().state;
  const activeWallet = wallets[shoppingCartName];
  if (!activeWallet) {
    logError(`No benefits wallet available for ${shoppingCartName}, you probably forgot to call listenBenefitsWallet beforehand.`);
  }
  await redeemCouponService(reusedConfig, code, selectedHeaders);
  await fetchWalletByUser(reusedConfig, selectedHeaders);
  const benefits = await (getWallet == null ? void 0 : getWallet({
    customerId,
    shoppingCartName
  }));
  if (!benefits) {
    throw new Error(`Failed to fetch benefits from firestore for the current customer after redeeming coupon`);
  }
  const updatedWallet = getInitialBenefitsWallet({
    benefits
  });
  const newInternalWallet = {
    benefits: [...updatedWallet.benefits],
    onSnapshot: activeWallet.onSnapshot
  };
  const newWallets = __spreadProps(__spreadValues$1({}, wallets), {
    [shoppingCartName]: newInternalWallet
  });
  State().setState({ wallets: newWallets });
  activeWallet.onSnapshot(updatedWallet);
};

const mergeShoppingCart = async (builders, shoppingCart, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { getShoppingCartNode, setDoc } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        const shoppingCartNode = await (getShoppingCartNode == null ? void 0 : getShoppingCartNode(reusedConfig));
        if (!shoppingCartNode) {
          logDebug("Cannot merge the shopping carts because no shopping cart nodes were usedConfig found. Please ensure you have a shopping cart before continue.");
          resolve(null);
          return null;
        }
        let destinyShoppingCart = shoppingCartNode.data();
        const stores = Object.values(shoppingCart.stores);
        stores.forEach((store) => {
          const products = Object.values(store.products);
          products.forEach((product) => {
            const { amount } = product;
            destinyShoppingCart = addProductToCartHelper(destinyShoppingCart, product, {
              store,
              amount
            });
          });
        });
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: destinyShoppingCart
        }));
        resolve(destinyShoppingCart);
        return destinyShoppingCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const updateShoppingCart = async (builders, setShoppingCart, config) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const { setDoc, getShoppingCartNode } = builders != null ? builders : {};
        const reusedConfig = reuseGlobalConfig(config);
        const { shoppingCartName } = reusedConfig;
        const shoppingCartNode = await getShoppingCartNode(reusedConfig);
        if (!shoppingCartNode) {
          console.warn(`Cannot update remote cart because no shopping cart was found. Please ensure you create a shopping cart with name ${shoppingCartName} before continue.`);
          resolve(null);
          return null;
        }
        const cart = await shoppingCartNode.data();
        const updatedCart = updateShoppingCartHelper(cart, setShoppingCart);
        await (setDoc == null ? void 0 : setDoc({
          reusedConfig,
          shoppingCartNode,
          payload: updatedCart
        }));
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};
const updateShoppingCartHelper = (cart, setShoppingCart) => {
  const updatedCart = __spreadValues(__spreadValues({}, cart), setShoppingCart(cart));
  return updatedCart;
};

export { ActionQueue, CONSTANTS, EventLoop, State, addProduct, addProductToCartHelper, applyBenefit, applyBenefitsHelper, buildInitialShoppingCart, buildServiceHeaders, checkInit, checkInitialized, checkMinimumConfigProvided, checkMinimumFetchWalletConfigProvided, cleanShoppingCart, closeShoppingCart, defaultSort, deleteShoppingCart, emptyShoppingCart, fetchStoreCouponDetail, fetchStoreCoupons, fetchWalletByUser, findProduct, getBenefitsNode, getInitialBenefitsWallet, getProductHash, getShoppingCart, getShoppingCartProducts, getShoppingCartTotal, getStore, getWallet, getWalletNode, initShoppingCart, logDebug, logError, mapCollectionToBenefits, mergeShoppingCart, pruneQuestionsAndAnswers, redeemCoupon, redeemCouponService, removeBenefit, removeBenefitsHelper, removeProduct, removeProductHelper, replaceProduct, replaceProductHelper, reuseGlobalConfig, setProduct, setProductHelper, sortByField, sortByProductId, sortByQuestionId, subtractProduct, subtractProductHelper, unsubscriber, updateBenefitsWallets, updateShoppingCart, validateShoppingCart, validateShoppingCart$1 as validateShoppingCartService, verifyHeaders };
//# sourceMappingURL=bundle.esm.js.map
